import { RouteConfig } from 'vue-router';
import VehicleOverview from '@/views/vehicles/Overview.vue';
import VehiclesManufacturers from '@/views/vehicles/VehiclesManufacturers.vue';
import VehicleManufacturer from '@/views/vehicles/VehicleManufacturer.vue';
import VehiclesModels from '@/views/vehicles/VehiclesModels.vue';
import PageModal from '@/components/modals/PageModal.vue';
import VehicleModel from '@/views/vehicles/VehicleModel.vue';

const routes: Array<RouteConfig> = [
	{
		path: '/vehicles',
		name: 'vehicles.overview',
		component: VehicleOverview,
		children: [
			{
				path: 'manufacturer',
				name: 'vehicles.manufacturer',
				component: PageModal,
				props: {
					title: 'Herstellerliste',
					component: VehiclesManufacturers,
				},
			},
			{
				path: 'manufacturer/new',
				name: 'vehicles.manufacturer.new',
				component: PageModal,
				props: {
					title: 'Neuer Hersteller',
					component: VehicleManufacturer,
					saveButtonText: 'Speichern',
				},
			},
			{
				path: 'manufacturer/:id',
				name: 'vehicles.manufacturer.id',
				component: PageModal,
				props: {
					title: 'Hersteller',
					component: VehicleManufacturer,
					saveButtonText: 'Speichern',
				},
			},

			{
				path: 'models',
				name: 'vehicles.models',
				component: PageModal,
				props: {
					title: 'Modellliste',
					component: VehiclesModels,
				},
			},
			{
				path: 'models/new',
				name: 'vehicles.model.new',
				component: PageModal,
				props: {
					title: 'Neues Modell',
					component: VehicleModel,
					saveButtonText: 'Speichern',
				},
			},
			{
				path: 'models/:id',
				name: 'vehicles.model.id',
				component: PageModal,
				props: {
					title: ' Eingabe des Modells kontrollieren / bestätigen',
					component: VehicleModel,
					saveButtonText: 'Speichern',
				},
			},
		],
	},
];

export default routes;
